import { BarChart10Icon } from '@langchain/untitled-ui-icons';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';

export function DashboardsCrumb(props: Partial<BreadcrumbData>) {
  return (
    <Breadcrumb
      icon={<BarChart10Icon className="h-4 w-4" />}
      name={'Monitoring'}
      {...props}
    />
  );
}
